import React, { createContext, useReducer, useContext, useMemo } from 'react';

/**
 * DEPRECATED
 *
 * Do not add new values here
 * Replace pseudo-redux with Apollo local state
 */

const Context = createContext();
const { Provider } = Context;

const initialState = {
  // Initial locale used to fetch ME query consistently
  initialLocale: undefined,
  // Locale code used to format dates and numbers
  locale: undefined
};

export const types = {
  setLocale: 'setLocale'
};

const reducer = (state, action) => {
  switch (action.type) {
    case types.setLocale:
      return { ...state, locale: action.payload };
    default:
      throw new Error();
  }
};

export const useAppReducer = () => useContext(Context);

export const AppReducer = ({ children, locale }) => {
  const [state, dispatch] = useReducer(reducer, {
    ...initialState,
    initialLocale: locale,
    locale
  });

  const actions = useMemo(
    () => ({
      [types.setLocale]: payload => dispatch({ type: types.setLocale, payload })
    }),
    [dispatch]
  );

  const value = { state, dispatch, ...actions };

  return <Provider value={value}>{children}</Provider>;
};
